export const underline = {
  group: 'underline',
  toDOM() {
    return ['u', 0];
  },
  parseDOM: [{
    tag: 'u'
  }, {
    style: 'text-decoration=underline'
  }]
};